<template>
    <div>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.99992 4.26852C9.60895 4.26852 9.29199 3.9516 9.29199 3.56059V0.70793C9.29199 0.316914 9.60895 0 9.99992 0C10.3909 0 10.7079 0.316914 10.7079 0.70793V3.56063C10.7079 3.9516 10.3909 4.26852 9.99992 4.26852Z"
                fill="white"
            />
            <path
                opacity="0.52"
                d="M9.99992 19.999C9.60895 19.999 9.29199 19.6821 9.29199 19.2911V16.4384C9.29199 16.0474 9.60895 15.7305 9.99992 15.7305C10.3909 15.7305 10.7079 16.0474 10.7079 16.4384V19.2911C10.7079 19.6821 10.3909 19.999 9.99992 19.999Z"
                fill="white"
            />
            <path
                opacity="0.58"
                d="M13.5117 19.3112C13.2326 19.3112 12.968 19.145 12.856 18.8707L11.778 16.2296C11.6303 15.8676 11.804 15.4544 12.1659 15.3067C12.5276 15.1587 12.9411 15.3325 13.0889 15.6945L14.1669 18.3356C14.3146 18.6976 14.1409 19.1109 13.779 19.2585C13.6914 19.2944 13.6008 19.3112 13.5117 19.3112Z"
                fill="white"
            />
            <path
                opacity="0.94"
                d="M12.4332 4.74699C12.3441 4.74699 12.2535 4.73012 12.1659 4.6943C11.8039 4.54664 11.6303 4.13336 11.778 3.77137L12.856 1.13023C13.0038 0.768241 13.417 0.594062 13.779 0.742382C14.141 0.890038 14.3146 1.30332 14.1669 1.66531L13.0889 4.30644C12.9769 4.58082 12.7123 4.74699 12.4332 4.74699Z"
                fill="white"
            />
            <path
                opacity="0.46"
                d="M6.48812 19.3113C6.39902 19.3113 6.30844 19.2944 6.22086 19.2586C5.85887 19.1109 5.68519 18.6976 5.83297 18.3356L6.91098 15.6945C7.05875 15.3325 7.47191 15.1587 7.83391 15.3067C8.1959 15.4544 8.36957 15.8676 8.2218 16.2296L7.14379 18.8708C7.0318 19.1451 6.76727 19.3113 6.48812 19.3113Z"
                fill="white"
            />
            <path
                opacity="0.36"
                d="M1.39708 14.219C1.11794 14.219 0.853408 14.0529 0.741416 13.7785C0.593643 13.4165 0.767315 13.0033 1.12927 12.8556L3.77036 11.7775C4.13231 11.6293 4.54556 11.8032 4.69333 12.1653C4.8411 12.5273 4.66743 12.9406 4.30548 13.0883L1.66438 14.1663C1.57681 14.2021 1.48618 14.219 1.39708 14.219Z"
                fill="white"
            />
            <path
                opacity="0.82"
                d="M15.962 8.27363C15.6829 8.27363 15.4183 8.10758 15.3064 7.83312C15.1586 7.47113 15.3323 7.05789 15.6942 6.9102L18.3353 5.83215C18.6971 5.68406 19.1105 5.85785 19.2583 6.22C19.406 6.58199 19.2324 6.99523 18.8704 7.14293L16.2293 8.22098C16.1417 8.25676 16.0511 8.27363 15.962 8.27363Z"
                fill="white"
            />
            <path
                opacity="0.24"
                d="M4.03792 8.27547C3.94881 8.27547 3.85823 8.2586 3.77061 8.22278L1.12952 7.14473C0.767525 6.99708 0.593892 6.58379 0.741665 6.2218C0.8894 5.85981 1.30252 5.68618 1.66463 5.83395L4.30573 6.912C4.66772 7.05965 4.84135 7.47294 4.69358 7.83493C4.58159 8.10926 4.31702 8.27547 4.03792 8.27547Z"
                fill="white"
            />
            <path
                opacity="0.7"
                d="M18.6026 14.2187C18.5135 14.2187 18.4229 14.2019 18.3353 14.166L15.6942 13.088C15.3322 12.9403 15.1586 12.5271 15.3064 12.1651C15.4541 11.8033 15.8673 11.6296 16.2293 11.7772L18.8704 12.8553C19.2324 13.0029 19.4061 13.4162 19.2583 13.7782C19.1463 14.0525 18.8817 14.2187 18.6026 14.2187Z"
                fill="white"
            />
            <path
                opacity="0.88"
                d="M14.5534 6.15368C14.3722 6.15368 14.1911 6.08454 14.0528 5.9463C13.7764 5.66989 13.7763 5.22165 14.0528 4.94524L16.0699 2.9281C16.3463 2.65157 16.7946 2.65157 17.071 2.9281C17.3475 3.2045 17.3475 3.65274 17.0711 3.92915L15.0539 5.9463C14.9157 6.08454 14.7345 6.15368 14.5534 6.15368Z"
                fill="white"
            />
            <path
                opacity="0.4"
                d="M3.42958 17.2787C3.24841 17.2787 3.06728 17.2095 2.92903 17.0713C2.65259 16.7949 2.65255 16.3466 2.92899 16.0702L4.9461 14.0531C5.22255 13.7766 5.67079 13.7766 5.94724 14.0531C6.22368 14.3295 6.22372 14.7777 5.94727 15.0541L3.93017 17.0713C3.79192 17.2095 3.61071 17.2787 3.42958 17.2787Z"
                fill="white"
            />
            <path
                opacity="0.18"
                d="M5.4467 6.15555C5.26549 6.15555 5.0844 6.08641 4.94612 5.94816L2.92901 3.93102C2.65256 3.65461 2.65256 3.20637 2.92905 2.92996C3.20545 2.65355 3.6537 2.65355 3.93018 2.92996L5.94729 4.94711C6.22373 5.22352 6.22374 5.67176 5.94725 5.94816C5.80905 6.08641 5.62784 6.15555 5.4467 6.15555Z"
                fill="white"
            />
            <path
                opacity="0.64"
                d="M16.5705 17.2786C16.3893 17.2786 16.2082 17.2095 16.0699 17.0712L14.0528 15.0541C13.7763 14.7777 13.7764 14.3294 14.0528 14.053C14.3293 13.7766 14.7775 13.7766 15.0539 14.053L17.0711 16.0702C17.3475 16.3466 17.3475 16.7948 17.071 17.0712C16.9329 17.2095 16.7516 17.2786 16.5705 17.2786Z"
                fill="white"
            />
            <path
                opacity="0.3"
                d="M3.56051 10.7088H0.70793C0.316953 10.7088 0 10.3919 0 10.0009C0 9.60988 0.316953 9.29297 0.70793 9.29297H3.56051C3.95148 9.29297 4.26844 9.60988 4.26844 10.0009C4.26844 10.3919 3.95148 10.7088 3.56051 10.7088Z"
                fill="white"
            />
            <path
                opacity="0.76"
                d="M19.292 10.7088H16.4394C16.0484 10.7088 15.7314 10.3919 15.7314 10.0009C15.7314 9.60988 16.0484 9.29297 16.4394 9.29297H19.292C19.683 9.29297 20 9.60988 20 10.0009C20 10.3919 19.683 10.7088 19.292 10.7088Z"
                fill="white"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'loading-icon',
    props: {
        width: {
            type: String,
            default: "18px"
        },
        height: {
            type: String,
            default: "18px"
        }
    }
};
</script>
